import React from 'react';
import { Typography } from '@material-ui/core';

interface Props {
  title: string;
  data?: string | number | JSX.Element;
  color?: 'primary' | 'secondary';
  dataColor?: string;
  smallLinks?: React.ReactNodeArray;
}

const ListCardSubtitle: React.FC<Props> = ({
  title,
  data,
  color = 'primary',
  dataColor,
  smallLinks,
}) => {
  return (
    <React.Fragment>
      <Typography variant='body2'>{title}</Typography>
      {smallLinks ? (
        smallLinks.map((l, i) => (
          <React.Fragment key={'small_links_' + i}>
            {l}
            {i < smallLinks.length - 1 && ', '}
          </React.Fragment>
        ))
      ) : (
        <Typography variant='body2' color={color}>
          {data}
        </Typography>
      )}
    </React.Fragment>
  );
};

export default ListCardSubtitle;
